// extracted by mini-css-extract-plugin
export default {"snake_game_container":"snake-game_snake_game_container__h5Evu"};